import { trpc } from '@tencent/tpro_rmonitor_manage_server_custom_event';
import { BusiCode } from '@/infrastructure/axios/code';
import AbstractHttpClient from '@/infrastructure/axios/request';
import { TrpcService } from '@/service/trpc';
import { WithTypeCast } from '@raft/utils';

export type IAddCustomEventReq = WithTypeCast<trpc.rmonitor.manage_server.IAddCustomEventReq>;
export type IAddCustomEventRsp = WithTypeCast<trpc.rmonitor.manage_server.IAddCustomEventRsp>;
export type IListCustomEventReq = WithTypeCast<trpc.rmonitor.manage_server.IListCustomEventReq>;
export type IListCustomEventRsp = WithTypeCast<trpc.rmonitor.manage_server.IListCustomEventRsp>;
export type ICustomEventInfo = WithTypeCast<trpc.rmonitor.manage_server.ICustomEventInfo>;
export type IDeleteCustomEventReq = WithTypeCast<trpc.rmonitor.manage_server.IDeleteCustomEventReq>;
export type IDeleteCustomEventRsp = WithTypeCast<trpc.rmonitor.manage_server.IDeleteCustomEventRsp>;
export type IUpdateCustomEventReq = WithTypeCast<trpc.rmonitor.manage_server.IUpdateCustomEventReq>;
export type IUpdateCustomEventRsp = WithTypeCast<trpc.rmonitor.manage_server.IUpdateCustomEventRsp>;
export type IEventDimension = WithTypeCast<trpc.rmonitor.manage_server.IEventDimension>;
export type FieldType = WithTypeCast<trpc.rmonitor.manage_server.FieldType>;
export type IShowHistoryReq = WithTypeCast<trpc.rmonitor.manage_server.IShowHistoryReq>;
export type IShowHistoryRsp = WithTypeCast<trpc.rmonitor.manage_server.IShowHistoryRsp>;
export type IHistory = WithTypeCast<trpc.rmonitor.manage_server.IHistory>;
export type IGetAllEventsReq = WithTypeCast<trpc.rmonitor.manage_server.IGetAllEventsReq>;
export type IGetAllEventsRsp = WithTypeCast<trpc.rmonitor.manage_server.IGetAllEventsRsp>;
export type IColumnInfo = WithTypeCast<trpc.rmonitor.manage_server.IColumnInfo>;
export type ColumnType = WithTypeCast<trpc.rmonitor.manage_server.ColumnType>;
export type Operator = WithTypeCast<trpc.rmonitor.manage_server.Operator>;

export type IEventInfo = WithTypeCast<trpc.rmonitor.manage_server.IEventInfo>;

export const { FieldType, ColumnType, Operator } = trpc.rmonitor.manage_server;


export class CustomEventService extends AbstractHttpClient {
  constructor() {
    super({
      serviceName: TrpcService.CustomEventService,
    });
  }

  public async listEvents(req: IGetAllEventsReq): Promise<IEventInfo[]> {
    try {
      const res = await this.trpcPost<IGetAllEventsRsp>('GetAllEvents', req);
      return res.eventInfo || [];
    } catch (e) {
      return [];
    }
  };

  public async list(req: IListCustomEventReq) {
    try {
      const res = await this.trpcPost<IListCustomEventRsp>('ListCustomEvent', req);
      return {
        total: res.total || 0,
        events: res.events || [],
      };
    } catch (e) {
      return {
        total: 0,
        events: [],
      };
    }
  };

  /**
   * 创建自定义事件配置
   * @param req
   */
  public async add(req: IAddCustomEventReq): Promise<boolean> {
    try {
      const res = await this.trpcPost<IAddCustomEventRsp>('AddCustomEvent', req);
      return res.baseRsp?.code === BusiCode.Ok;
    } catch (e) {
      return false;
    }
  }

  /**
   * 修改自定义事件配置
   * @param req
   */
  public async update(req: IUpdateCustomEventReq): Promise<boolean> {
    try {
      const res = await this.trpcPost<IUpdateCustomEventRsp>('UpdateCustomEvent', req);
      return res.baseRsp?.code === BusiCode.Ok;
    } catch (e) {
      return false;
    }
  }

  /**
   * 删除自定义事件配置
   * @param req
   */
  public async delete(req: IDeleteCustomEventReq): Promise<boolean> {
    try {
      const res = await this.trpcPost<IDeleteCustomEventRsp>('DeleteCustomEvent', req);
      return res.baseRsp?.code === BusiCode.Ok;
    } catch (e) {
      return false;
    }
  }

  public async showHistory(req: IShowHistoryReq): Promise<IHistory[]> {
    try {
      const res = await this.trpcPost<IShowHistoryRsp>('ShowHistory', req);
      return res.history || [];
    } catch (e) {
      return [];
    }
  };
}

export const customEventService = new CustomEventService();
